/**
 * RatingStars - Display a 1-5 star rating with visual icons.
 */

import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RatingStarsProps {
  rating: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RatingStars({ rating, size = 'sm', className }: RatingStarsProps) {
  const maxStars = 5;
  const filledStars = Math.min(Math.max(0, rating), maxStars);

  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const gapClasses = {
    sm: 'gap-0.5',
    md: 'gap-1',
    lg: 'gap-1',
  };

  return (
    <div className={cn('flex items-center', gapClasses[size], className)}>
      {Array.from({ length: maxStars }, (_, i) => (
        <Star
          key={i}
          className={cn(
            sizeClasses[size],
            i < filledStars
              ? 'fill-yellow-400 text-yellow-400'
              : 'fill-transparent text-muted-foreground/30'
          )}
        />
      ))}
    </div>
  );
}
